import { render, staticRenderFns } from "./ProxyManage.vue?vue&type=template&id=f5c42ad6&scoped=true"
import script from "./ProxyManage.vue?vue&type=script&lang=js"
export * from "./ProxyManage.vue?vue&type=script&lang=js"
import style0 from "./ProxyManage.vue?vue&type=style&index=0&id=f5c42ad6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c42ad6",
  null
  
)

export default component.exports